<template>
  <div>
    <v-data-table
      v-bind="dataConfig"
      :item-class="itemRowBackground"
      :show-rows-border="false"
      no-data-text="No hay datos para mostrar"
      :items-per-page="-1"
      :class="tableClass"
      hide-default-footer
      @page-count="pageCount = $event"
      :items="itemsTest"
      :headers="headersFormat"
      :disable-pagination="pagination"
      :loading="loading"
    >
      <template v-for="(_, slot) in $scopedSlots" v-slot:[slot]="props">
        <slot :name="slot" v-bind="props"> </slot>
      </template>
      <template v-slot:no-data>
        <slot name="no-data" />
      </template>
    </v-data-table>
    <div v-if="pagination">
      <div class="text-center mt-4 mb-10" v-if="itemsFormated.length !== 0">
        <app-custom-pagination-component
          v-model="page"
          :total-pages="totalPages"
          :items-per-page="itemsPerPage"
          :per-page="itemsPerPage"
          :total-registros="totalRegistros"
          :show-per-page-selector="true"
          @change="changePagina"
          @per-page-changed="handlePerPageChange"
          class="principalPagination"
        >
        </app-custom-pagination-component>
      </div>
    </div>
  </div>
</template>

<script>
import AppCustomPaginationComponent from './AppCustomPaginationComponent.vue';
export default {
  name: 'AppDataTable',
  components: {
    AppCustomPaginationComponent,
  },
  props: {
    dataConfig: {
      type: Object,
      default: () => {},
    },
    itemsPerPage: {
      type: Number,
      default: 10,
    },
    totalPages: {
      type: Number,
      default: 10,
    },
    pagination: {
      type: Boolean,
      default: true,
    },
    tableClass: {
      type: String,
      default: 'elevation-3 rounded-xl striped-rows no-hover',
    },
    correlativo: {
      type: Boolean,
      default: true,
    },
    sortDescDefault: {
      type: Boolean,
      default: false,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    correlativeText: {
      type: String,
      default: 'N°',
    },
    sortDescId: {
      type: Boolean,
      default: true,
    },
    totalRegistros: {
      type: Number,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      page: 1,
      sortBy: 'id',
      sortDesc: this.sortDescDefault,
    };
  },
  computed: {
    itemsPerPageSync: {
      get() {
        return this.itemsPerPage;
      },
      set(value) {
        this.$emit('update:itemsPerPage', value);
      },
    },
    itemsFormated() {
      if (!Array.isArray(this.dataConfig.items)) return [];
      return this.dataConfig.items.map((value, index) => {
        if (this.correlativo) {
          value.correlativo =
            this.dataConfig.items.length < 999
              ? (
                  '000' +
                  (this.page * this.itemsPerPage -
                    this.itemsPerPage +
                    (index + 1))
                ).slice(-3)
              : this.page * this.itemsPerPage - this.itemsPerPage + (index + 1);
        }
        return value;
      });
    },
    itemsTest() {
      if (this.sortDescId) {
        return this.itemsFormated.sort((a, b) => b.id - a.id);
      } else {
        return this.itemsFormated;
      }
    },
    headersFormat() {
      const headers = [];
      // if (this.correlativo) {
      //     headers.push({
      //         text: this.correlativeText,
      //         value: "correlativo",
      //         sortable: false,
      //     });
      // }
      headers.push(...this.dataConfig.headers);
      return headers.map((value, index) => {
        value.class = 'no-border font-weight-black black--text py-5';
        return value;
      });
    },
  },
  watch: {
    currentPage() {
      this.page = this.currentPage;
    },
  },
  methods: {
    changePagina(nuevo, old) {
      this.$emit('paginationChange', nuevo);
    },
    handlePerPageChange(newPerPage) {
      this.itemsPerPageSync = newPerPage;
      this.page = 1;
      this.$emit('perPageChange', newPerPage);
    },
    itemRowBackground(item) {
      //return item.correlativo % 2 === 1 ? "bgTableFila " : "bgWhite";
    },
  },
  created() {
    this.page = this.currentPage;
  },
};
</script>
<style scoped>
/* Alternar colores en las row */
.principalPagination >>> .pagination {
  display: block !important;
}

::v-deep .striped-rows tbody tr:nth-child(odd) {
  background-color: #ededf1;
}

::v-deep .striped-rows tbody tr:nth-child(even) {
  background-color: white;
}
/* Quitar efecto hover */
::v-deep .no-hover tbody tr:hover {
  background-color: var(--app-dt-hover-bg, #eeeeee) !important;
}
</style>

<style lang="scss" scoped>
:deep(
    .theme--light.v-data-table
      > .v-data-table__wrapper
      > table
      > thead
      > tr:last-child
      > th.sortable
  ) {
  text-align: center !important;
}

:deep(
    .theme--light.v-data-table
      > .v-data-table__wrapper
      > table
      > thead
      > tr:last-child
      > th
  ) {
  text-align: center !important;
  font-weight: bold !important;
  font-size: 14px !important;
}

:deep(
    .theme--light.v-data-table
      > .v-data-table__wrapper
      > table
      > thead
      > tr:last-child
      > th
  ) {
  text-align: center !important;
  font-weight: bold !important;
}

:deep(
    .v-data-table > .v-data-table__wrapper > table > thead > tr > td,
    .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td
  ) {
  font-size: 0.875rem;
  height: 48px;
  text-align: center !important;
}

:deep(.v-data-table__empty-wrapper) {
  color: #000000 !important;
}

::v-deep .v-data-table tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}

::v-deep .v-data-table tbody tr:hover td {
  background-color: rgba(0, 0, 0, 0.04) !important;
}

:deep(.v-data-table thead tr th) {
  text-align: center !important;
}

:deep(
    .v-data-table
      > .v-data-table__wrapper
      > table
      > tbody
      > tr:last-child
      > td:first-child
  ) {
  border-bottom-left-radius: 14px !important;
}

:deep(
    .v-data-table
      > .v-data-table__wrapper
      > table
      > tbody
      > tr:last-child
      > td:last-child
  ) {
  border-bottom-right-radius: 14px !important;
}
</style>
